<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-12 col-md-6">
        <app-breadcrumb
          page-title="Historicos"
          :directory="subTitle"
          :icon="'trello'"
        />
      </div>

      <div class="col-12 mb-3">
        <div class="float-md-right">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="
              () => {
                $hub.$emit('reload-table');
              }
            "
          >
            Refrescar
          </button>
          <!-- <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            @click="returnPage()"
          >
            {{ $t("back") }}
          </button> -->
        </div>
      </div>

      <div class="col-md-12">
        <app-tab :tabs="tabs" type="horizontal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    accAppId: String,
  },
  data() {
    return {
      tabs: [
        {
          icon: "briefcase",
          name: "Accreditación",
          component: "historical-accreditation",
          permission: "",
        },
        {
          icon: "send",
          name: "Evaluaciones",
          component: "historical-evaluation",
          permission: "",
        },
        {
          icon: "home",
          name: "Testificaciones",
          component: "historical-testification",
          permission: "",
        },
        {
          icon: "send",
          name: "Alcances Registrados",
          component: "scopes-evaluator-indexx",
          permission: "",
        },
        {
          icon: "briefcase",
          name: "Plan de Mantenimiento",
          component: "historical-maintenances-plan",
          permission: "",
        },
      ],
    };
  },
  computed: {
    accApp() {
      return this.$store.state.common.accApp;
    },
    subTitle() {
      if (this.accApp != null) {
        if (this.accApp.revision_v10) {
          return `${this.accApp.accreditation_area.name} - ${this.accApp.accreditation_activity.name} - ${this.accApp.accreditation_type.name} <span class="badge badge-sm badge-pill badge-success">PA06 R11</span>`;
        } else {
          return `${this.accApp.accreditation_area.name} - ${this.accApp.accreditation_activity.name} - ${this.accApp.accreditation_type.name} <span class="badge badge-sm badge-pill badge-warning">PA06 R09</span>`;
        }  
      } else {
        return "";
      }
    },
  },
  created() {
    this.$store.state.common.accAppId = this.accAppId;
    this.getActivity();
  },
  methods: {
    returnPage() {
      window.location.href = "/historical";
    },
    getActivity() {
      axios
        .get(
          `/evaluator/documentaryEvaluation/activity/${this.$store.state.common.accAppId}?accApp=1`
        )
        .then((res) => {
          this.$store.state.accreditation.id = res.data.id;
          this.$store.state.accreditation.app = res.data;
        });
    },
  },
};
</script>
